import React, { useEffect, useRef, useState } from 'react'
const MAX_HEIGHT = 160;

const CollapsableContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const contentRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const el = contentRef.current;
        if (!el) return;

        const observer = new ResizeObserver(() => {
            setIsOverflowing(el.scrollHeight > MAX_HEIGHT);
        });

        observer.observe(el);

        return () => observer.disconnect();
    }, []);

    return (
        <div>
            <div ref={contentRef} className={`collapsible-content ${isExpanded ? 'expanded' : ''}`}>
                {children}
                {!isExpanded && isOverflowing && <div className="fade-overlay" />}

            </div>
            {isOverflowing && (
                <div
                    className="read-more-button p-2 m-0"
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    {isExpanded ? 'Show less' : 'Show more'}
                </div>
            )}
        </div>
    )
}

export default CollapsableContent